import * as React from 'react';
import { Box, Typography } from '@drone-js/core';
import { getDateTypographyColor, getDateBackgroundColor } from './DatePicker.mappers.js';

var MonthYearButton = function MonthYearButton(props) {
  var tabIndex = props.tabIndex,
    selected = props.selected,
    disabled = props.disabled,
    label = props.label,
    onKeyDown = props.onKeyDown;
  var typographyColor = getDateTypographyColor(disabled, selected);
  var backgroundColor = getDateBackgroundColor(selected);
  return /*#__PURE__*/React.createElement(Box, {
    as: "td",
    flex: 1,
    textAlign: "center",
    verticalAlign: "middle",
    onClick: props.onClick,
    p: "0"
  }, /*#__PURE__*/React.createElement(Box, {
    as: "button",
    tabIndex: tabIndex,
    borderRadius: "8",
    py: "8",
    px: "16",
    width: "100%",
    interactive: disabled ? undefined : 'product.primary',
    disabled: disabled,
    cursor: disabled ? 'default' : 'pointer',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    mx: "auto",
    position: "relative",
    backgroundColor: backgroundColor,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body-default",
    textColor: typographyColor,
    interactive: selected ? 'none' : undefined
  }, label)));
};

export { MonthYearButton };
//# sourceMappingURL=MonthYearButton.js.map
